import { render, staticRenderFns } from "./ChoroplethLayer.vue?vue&type=template&id=54d665f5&"
import script from "./ChoroplethLayer.vue?vue&type=script&lang=js&"
export * from "./ChoroplethLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports